/* template */
<template><span class="text-tag"><span v-if="(lang === 'zh-CN')"><span class="icon icon-saved" v-if="(tip ==='省')">省</span><span class="icon icon-deduction" v-else-if="(tip ==='抵')">抵</span><span class="icon icon-limit" v-else-if="(tip === '限')">限</span><span class="icon icon-send" v-else-if="(tip === '赠')">赠</span><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/feac4fd9-b5da-4946-9054-816323bce4b3.png" class="icon icon-recommend" v-else-if="(tip === '荐')"/></span><span :class='("text "+(isMiniProgram ? "padding-left" : ""))'>{{text}}</span></span></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mfef5a77c"}'>
@import '../../lib/stylus/border'
iconColor = {
  saved: #28AA91,
  limit: #FF525D,
  deduction: #FC9153,
  send: #CC7E19,
}
.padding-left
  padding-left: 6rpx
.text-tag
  line-height: 32rpx
  font-size: 24rpx
  .text
    color: #999
  .icon
    border-radius: 2rpx
    font-family: PingFangSC-Regular
    display: inline-block
    width: 32rpx
    height: 32rpx
    box-sizing: border-box
    text-align: center
    &::after
      border-radius: 2px
  .icon-saved
    color: iconColor.saved
    border-1px(,,,iconColor.saved)
  .icon-limit
    color: iconColor.limit
    border-1px(,,,iconColor.limit)
  .icon-deduction
    color: iconColor.deduction
    border-1px(,,,iconColor.deduction)
  .icon-send
    color: iconColor.send
    border-1px(,,,iconColor.end)
  .icon-recommend
    width: 32rpx
    height: 32rpx
    vertical-align: middle
    background-size: 100% 100%
    &.android
      margin-bottom: -2rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { isMiniProgram, isAliProgram } from '../../lib/js/env'
import store from '../../store'
createComponent({
  properties: {
    tip: String,
    text: String,
  },
  data: {
    isMiniProgram: isMiniProgram() || isAliProgram(),
  },
  computed: {
    lang() {
      return store.getters.lang
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "text-tagfef5a77c",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
